import JwtDecode from 'jwt-decode'

export default class User {
  static from(token) {
    try {
      let obj = JwtDecode(token)
      let user = new User(obj)
      return user
    } catch (_) {
      return null
    }
  }

  constructor({ payload, iat, exp }) {
    this.appName=process.env.APP_NAME
    this.email = payload.email
    this.firstname = payload.firstname
    this.lastname = payload.lastname
    this.type = payload.app.find(app => app.name.toLowerCase() === this.appName) ? payload.app.find(app => app.name.toLowerCase() === this.appName).role.toLowerCase() : 'unauthorized'
    this.organization = payload.organization
    this.activation = payload.app.activation
    this.expiration = payload.app.expiration
    this.exp = exp
    this.id = payload.userid
    this.iat = iat
  }

  get isAdmin () {
    return this.type === 'admin'
  }

  get jwtIsExpired () {
    return this.exp > Math.floor(new Date().getTime() / 1000)
  }
}
